/* eslint-disable react/no-danger, react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import {css} from '@emotion/react'
import Img from 'gatsby-image'
import {createMarkup} from '../../../util/datoCmsDataFactory'
import {colors} from '../../../constants'

const SideBySide = ({
    imageSrc,
    animationJson,
    imageMaxHeight,
    gatsbyImage,
    title,
    titleBgColor,
    description, // this will be an html string
    imagePosition, // left|right
    overrideStyles,
}) => {
    const options = {
        loop: true,
        autoplay: true,
        animationData: animationJson,
    }
    return (
        <div
            className="side-by-side"
            css={css`
                display: flex;
                flex-direction: ${imagePosition === 'left' ? 'row' : 'row-reverse'};
                align-items: center;
                .side-by-side-text {
                    margin: ${imagePosition === 'left' ? '0 0 0 2rem' : '0 2rem 0 0'};
                }
                h3 {
                    margin: 0 0 1rem;
                    flex: 0 0 50%;
                    font-size: 40px;
                    font-weight: 800;
                }
                img {
                    margin: ${imagePosition === 'left' ? '0 2rem 0 0' : '0 0 0 2rem'};
                    width: 100%;
                    flex: 0 0 50%;
                    ${imageMaxHeight && `max-height: ${imageMaxHeight};`}
                }
                opacity: ${animationJson ? '1' : 0};
                transition: opacity 1s ease;
                ${overrideStyles}
            `}
        >
            <div className="side-by-side-image">
                {imageSrc && <img src={imageSrc} alt="privacy-icon" className="side-by-side-image" />}
                {gatsbyImage && <Img fixed={gatsbyImage} />}
                {animationJson && (
                    <Lottie
                        options={options}
                        style={{
                            height: '400px',
                            width: '400px',
                            transform: 'scale(1.13)',
                        }}
                    />
                )}
            </div>
            <div className="side-by-side-text">
                <div
                    className="title-section"
                    css={css`
                        position: relative;
                        width: fit-content;
                    `}
                >
                    <div
                        className="title-background"
                        css={css`
                            height: 19px;
                            width: calc(100% + 20px);
                            background: ${titleBgColor || colors.whisperDark};
                            position: absolute;
                            bottom: 4px;
                            left: -10px;
                        `}
                    />
                    <h3
                        css={css`
                            position: relative;
                        `}
                    >
                        {title}
                    </h3>
                </div>
                <div
                    className="details"
                    css={css`
                        line-height: 24px;
                        font-size: 16px;
                    `}
                    dangerouslySetInnerHTML={createMarkup(description)}
                />
            </div>
        </div>
    )
}

SideBySide.propTypes = {
    animationJson: PropTypes.object,
    imageSrc: PropTypes.string,
    title: PropTypes.string,
    titleBgColor: PropTypes.string,
    description: PropTypes.string,
    imagePosition: PropTypes.string,
    overrideStyles: PropTypes.any,
}

export default SideBySide
